import React, { useState, useEffect } from 'react';
import './../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BannerHomeTop } from "./banner";
import BannerHome from '../img/home/banner-home.png';

function Home() {
  const [conteudo, setConteudo] = useState({ classe: "" });
  const [dataAtingida, setDataAtingida] = useState(false);
  const dataBlackFriday = new Date('2025-11-28T23:59:59');
  const dataProrrogado = new Date('2025-11-29T00:00:00');
  const dataCyber = new Date('2025-12-01T00:00:00');

  useEffect(() => {
    document.body.classList.add('smarthint');
    const verificarData = () => {
      const dataAtual = new Date();
      
      if (dataAtual <= dataBlackFriday) {
        setConteudo({ classe: "black" });
        document.body.classList.add('black-friday');
        setDataAtingida(true);
      } else if (dataAtual >= dataProrrogado && dataAtual < dataCyber) {
        setConteudo({ classe: "cyber" });
        document.body.classList.add('cyber-week');
        setDataAtingida(true);
      } else if (dataAtual > dataBlackFriday && dataAtual >= dataCyber) {
        setConteudo({ classe: "cyber" });
        document.body.classList.add('cyber-week');
        setDataAtingida(true);
      }
    };

    verificarData();

    const intervalo = setInterval(verificarData, 60000);

    return () => clearInterval(intervalo);
  }, []);

  const linkHref = () => {
    switch (conteudo.classe) {
      case "black":
        return "https://www.futfanatics.com.br/loja/busca.php";
      case "prorrogado":
        return "https://www.futfanatics.com.br/loja/busca.php";
      case "cyber":
        return "https://www.futfanatics.com.br/loja/busca.php";
      default:
        return "https://www.futfanatics.com.br";
    }
  };

  return (
    <a className="w-100" href={linkHref()}>

      <section className={`c-home ${dataAtingida ? conteudo.classe : ''}`}>
      </section>
    </a>
  );
}

export default Home;
